/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Links_FreeInputs */

const en_landing_pricing_compare_links_free = /** @type {(inputs: Landing_Pricing_Compare_Links_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow`)
};

const zh_landing_pricing_compare_links_free = /** @type {(inputs: Landing_Pricing_Compare_Links_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow`)
};

/**
* | output |
* | --- |
* | "Nofollow" |
*
* @param {Landing_Pricing_Compare_Links_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_links_free = /** @type {((inputs?: Landing_Pricing_Compare_Links_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Links_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_links_free(inputs)
	return zh_landing_pricing_compare_links_free(inputs)
});
export { landing_pricing_compare_links_free as "landing.pricing.compare_links_free" }